import styled from "styled-components";
import { Attribute, AttributeGroup, AttributeProperty, ComponentProps, ContainerAttributes, FontTheme, LinkTheme } from "react-builder";

@AttributeGroup({ title: 'DownloadGallery', blockName: 'DownloadGallery', module: 'downloads' })
export class DownloadGalleryAttributes extends Attribute {

    @AttributeProperty({ type: 'Object', cssTarget: ' .nameTitle' })
    title: FontTheme = new FontTheme();
    @AttributeProperty({ type: 'Object', cssTarget: ' ul li a' })
    link: LinkTheme = new LinkTheme().fromJSON({ static: { font: { color: 'white', textAlign: 'center' }, container: { justifyContent: 'center' } } });
    @AttributeProperty({ type: 'Object', title: 'Card', cssTarget: ' .download-icons' })
    card: ContainerAttributes = new ContainerAttributes().fromJSON({
        width: '50%',
        maxWidth: '130px'
    })
    @AttributeProperty({ type: 'Object', title: 'Wrapper', cssTarget: ' .download-wrap' })
    wrapper: ContainerAttributes = new ContainerAttributes().fromJSON({
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'center',
        maxWidth: '1000px',
        margin: 'auto',
        gap: '10px'
    })
}

const DownloadGalleryTheme = styled.div((props: { attributes: DownloadGalleryAttributes }) => `

    margin: 0 auto;
    /* background-color: #1a1a1a; */
    flex-direction: column;

    h1 {
        padding-top: 20px;
        letter-spacing: 2px;
        font-size: 24px;
        text-transform: uppercase;
        text-align: center;
        color: #fff;

        /* @include mqbp(x-small) {
        letter-spacing: 0px;
        font-size: 22px;
        padding: 10px 40px;
        } */
    }
    
    .download-wrapper {
        margin: 0 auto;
        padding: 60px 80px 50px;
        max-width: 1600px;
        /////////button///////////////////
        button {
        display: flex;
        padding: 10px 30px;
        background: #333;
        border-radius: 8px;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        font-weight: 500;
        font-size: 14px;
        &:hover {
            background: #000;
            color: $theme-color;
        }
        }
        h2 {
        padding-bottom: 20px;
        text-align: center;
        letter-spacing: 1px;
        display: grid;
        grid-template-columns: 1fr auto 1fr;
        grid-template-rows: 16px 0;
        grid-gap: 35px;
        font-size: 20px;
        font-weight: 700;
        color: #008cff;
        /* @include mqbp(x-small) {
            font-size: 18px;
        } */

        &:after,
        &:before {
            content: " ";
            display: block;
            border-bottom: 1px solid #008cff;
        }
        }

        /* @include mqbp(x-small) {
        padding: 20px 0px 30px;
        } */
    }

    .icon {
        position: relative;

        figure {
            margin: 0 auto;
        }
        .content {
            display: none;
            position: absolute;
            top: 0px;
            left: 0px;
            border-radius: 23px;
            width: 100%;
            /* @include mqbp(medium) {
                border-radius: 10px;
                padding: 5px 0px 8px;
                position: relative !important;
            } */
        }

        &:hover > .content {
            display: block;
            opacity: 1;
            transition: 0.5s;
            background-color: rgba(0, 0, 0, 0.5);
            transition: opacity 2s linear;
            transform: translate(0);
        }
    }

    .content {
        padding: 15px 0px;
        border-radius: 4px;
        transition: background-color 0.5s ease;
        transition: 0.5s;
        border-radius: 8px;
        flex: 1;
        height: 100%;
    }

    ul {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
        padding: 0;
        margin: 0;
        width: 100%;
    }

    /* .material-icons {
        font-size: 20px;
        @include mqbp(small) {
            font-size: 15px;
            padding-inline-start: 13px;
        }
    } */
    ul{
        a {
        padding: 1px 0px;
        margin: 1px 9px 0px;
        background-color: #000;
        border-radius: 6px;
        border: 2px solid #2a2b33;
        color: #fff;
        display: flex;
        align-items: center;
        gap: 10px;
        font-size: 13px;
        font-weight: 400;
        line-height: 22px;
        /* @include mqbp(x-large) {
            padding-inline-start: 20px;
        }
        @include mqbp(small) {
            margin: 1px 8px 0px;
            padding-inline-start: 0px;
            padding: 0px 0px;
            font-size: 9px;
            line-height: 15px;
        } */
        &:hover {
            background: #333;
            color: $theme-color;
        }
        }
    }
    .other {
        a {
        display: block;
        padding-inline-start: 0px;
        text-align: center;
        }
    }
    .windows a {
        .material-icons {
        font-size: 12px;
        }
    }

    .download-wrap {
        /* display: grid;
        gap: 10px;
        grid-template-columns: repeat(6, 1fr);
        @include mqbp(x-large) {
        grid-template-columns: repeat(8, 1fr);
        }
        @include mqbp(large) {
        grid-template-columns: repeat(6, 1fr);
        }
        @include mqbp(medium) {
        grid-template-columns: repeat(4, 1fr);
        padding: 0px 10px;
        }
        @include mqbp(x-small) {
        grid-template-columns: repeat(3, 1fr);
        padding: 0px 10px;
        } */
    }

    .download-icons {
        // transform: scale(1);
        text-align: center;
        color: #7f7f7f;
        cursor: pointer;
        // &:hover {
        //   filter: grayscale(100%);
        // transition: 0.1s;
        // transform: scale(1.1);
        // padding:1px;
        // }
    }

    img{
        display: block;
    }

    ${props.attributes.toCSS()}

`);

function DownloadGallery(props: ComponentProps<DownloadGalleryAttributes>) {

    const android = () => <svg xmlns="http://www.w3.org/2000/svg" fill="white" height="24" viewBox="0 -960 960 960" width="24"><path d="M40-240q9-107 65.5-197T256-580l-74-128q-6-9-3-19t13-15q8-5 18-2t16 12l74 128q86-36 180-36t180 36l74-128q6-9 16-12t18 2q10 5 13 15t-3 19l-74 128q94 53 150.5 143T920-240H40Zm240-110q21 0 35.5-14.5T330-400q0-21-14.5-35.5T280-450q-21 0-35.5 14.5T230-400q0 21 14.5 35.5T280-350Zm400 0q21 0 35.5-14.5T730-400q0-21-14.5-35.5T680-450q-21 0-35.5 14.5T630-400q0 21 14.5 35.5T680-350Z" /></svg>
    const apple = () => <svg xmlns="http://www.w3.org/2000/svg" fill="white" height="19" version="1.1" id="Capa_1" viewBox="0 0 22.773 22.773">
        <g>
            <g>
                <path d="M15.769,0c0.053,0,0.106,0,0.162,0c0.13,1.606-0.483,2.806-1.228,3.675c-0.731,0.863-1.732,1.7-3.351,1.573    c-0.108-1.583,0.506-2.694,1.25-3.561C13.292,0.879,14.557,0.16,15.769,0z" />
                <path d="M20.67,16.716c0,0.016,0,0.03,0,0.045c-0.455,1.378-1.104,2.559-1.896,3.655c-0.723,0.995-1.609,2.334-3.191,2.334    c-1.367,0-2.275-0.879-3.676-0.903c-1.482-0.024-2.297,0.735-3.652,0.926c-0.155,0-0.31,0-0.462,0    c-0.995-0.144-1.798-0.932-2.383-1.642c-1.725-2.098-3.058-4.808-3.306-8.276c0-0.34,0-0.679,0-1.019    c0.105-2.482,1.311-4.5,2.914-5.478c0.846-0.52,2.009-0.963,3.304-0.765c0.555,0.086,1.122,0.276,1.619,0.464    c0.471,0.181,1.06,0.502,1.618,0.485c0.378-0.011,0.754-0.208,1.135-0.347c1.116-0.403,2.21-0.865,3.652-0.648    c1.733,0.262,2.963,1.032,3.723,2.22c-1.466,0.933-2.625,2.339-2.427,4.74C17.818,14.688,19.086,15.964,20.67,16.716z" />
            </g>
        </g>
    </svg>;

    return (
        <DownloadGalleryTheme {...props} attributes={props.attributes}>
            <div className="download-wrap">
                <div className="download-icons">
                    <div className="icon">
                        <div id="window-1" className="img">
                            <figure> <img src="https://hp.entertzone.com/images/download-icons/icon-17.png" /> </figure>
                        </div>
                        <div className="content fade-in">
                            <ul>
                                <li className="pc"><a href="https://play.google.com/store/apps/details?id=com.mint" target="_blank">{android()}Android</a></li>
                                <li className="mac"><a href="https://apps.apple.com/us/app/mint-personal-finance-money/id300238550" target="_blank">{apple()}MAC</a></li>
                                <li className="other"><a href="https://mint.intuit.com/" target="_blank">Other</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="nameTitle">Mint</div>
                </div>

                <div className="download-icons">
                    <div className="icon">
                        <div id="window-1" className="img">
                            <figure> <img src="https://hp.entertzone.com/images/download-icons/icon-11.png" /> </figure>
                        </div>
                        <div className="content fade-in">
                            <ul>
                                <li className="pc"><a href="https://play.google.com/store/apps/details?id=com.amazon.dee.app&amp;hl=en&amp;gl=US" target="_blank">{android()}Android</a></li>
                                <li className="mac"><a href="https://apps.apple.com/us/app/amazon-alexa/id944011620" target="_blank">{apple()}MAC</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="nameTitle">Alexa</div>


                </div>

                <div className="download-icons">
                    <div className="icon">
                        <div id="window-1" className="img">
                            <figure> <img src="https://hp.entertzone.com/images/download-icons/icon-4.png" /> </figure>
                        </div>
                        <div className="content fade-in">
                            <ul>
                                <li className="pc"><a href="https://play.google.com/store/apps/dev?id=6720847872553662727" target="_blank">{android()}Android</a></li>
                                <li className="mac"><a href="https://apps.apple.com/us/developer/microsoft-corporation/id298856275" target="_blank">{apple()}MAC</a></li>
                                <li className="other"><a href="https://www.office.com/" target="_blank">Other</a></li>

                            </ul>
                        </div>
                    </div>
                    <div className="nameTitle">Office</div>

                </div>

                <div className="download-icons">
                    <div className="icon">
                        <div id="window-1" className="img">
                            <figure> <img src="https://hp.entertzone.com/images/download-icons/icon-5.png" /> </figure>
                        </div>
                        <div className="content fade-in">
                            <ul>
                                <li className="pc"><a href="https://play.google.com/store/apps/details?id=com.adobe.psmobile" target="_blank">{android()}Android</a></li>
                                <li className="mac"><a href="https://apps.apple.com/us/app/adobe-photoshop-express/id331975235" target="_blank">{apple()}MAC</a></li>
                                <li className="other"><a href="https://www.adobe.com/products/photoshop-express.html" target="_blank">Other</a></li>

                            </ul>
                        </div>
                    </div>
                    <div className="nameTitle">Photoshop</div>

                </div>
                <div className="download-icons">
                    <div className="icon">
                        <div id="window-1" className="img">
                            <figure> <img src="https://hp.entertzone.com/images/download-icons/icon-27.png" /> </figure>
                        </div>
                        <div className="content fade-in">
                            <ul>
                                <li className="pc"><a href="https://play.google.com/store/apps/details?id=com.google.android.talk" target="_blank">{android()}Android</a></li>
                                <li className="mac"><a href="https://apps.apple.com/us/app/hangouts/id643496868" target="_blank">{apple()}MAC</a></li>
                                <li className="other"><a href="https://hangouts.google.com/" target="_blank">Other</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="nameTitle">Hangouts</div>

                </div>
                <div className="download-icons">
                    <div className="icon">
                        <div id="window-1" className="img">
                            <figure> <img src="https://hp.entertzone.com/images/download-icons/icon-28.png" /> </figure>
                        </div>
                        <div className="content fade-in">
                            <ul>
                                <li className="pc"><a href="https://play.google.com/store/apps/details?id=com.google.android.apps.tachyon&amp;gl=NL" target="_blank">{android()}Android</a></li>
                                <li className="mac"><a href="https://apps.apple.com/nl/app/google-duo/id1096918571" target="_blank">{apple()}MAC</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="nameTitle">Google Duo</div>

                </div>
                <div className="download-icons">
                    <div className="icon">
                        <div id="window-1" className="img">
                            <figure> <img src="https://hp.entertzone.com/images/download-icons/icon-29.png" /> </figure>
                        </div>
                        <div className="content fade-in">
                            <ul>
                                <li className="pc"><a href="https://play.google.com/store/apps/details?id=com.netflix.mediaclient&amp;gl=NL" target="_blank">{android()}Android</a></li>
                                <li className="mac"><a href="https://apps.apple.com/nl/app/netflix/id363590051" target="_blank">{apple()}MAC</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="nameTitle">Netflix</div>

                </div>
                <div className="download-icons">
                    <div className="icon">
                        <div id="window-1" className="img">
                            <figure> <img src="https://hp.entertzone.com/images/download-icons/icon-22.png" /> </figure>
                        </div>
                        <div className="content fade-in">
                            <ul>
                                <li className="pc"><a href="https://play.google.com/store/apps/details?id=com.goodreads&amp;hl=en&amp;gl=US" target="_blank">{android()}Android</a></li>
                                <li className="mac"><a href="https://apps.apple.com/us/app/goodreads-book-reviews/id355833469" target="_blank">{apple()}MAC</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="nameTitle">Goodreads: Book Review</div>

                </div>
                <div className="download-icons">
                    <div className="icon">
                        <div id="window-1" className="img">
                            <figure> <img src="https://hp.entertzone.com/images/download-icons/icon-23.png" /> </figure>
                        </div>
                        <div className="content fade-in">
                            <ul>
                                <li className="pc"><a href="https://play.google.com/store/apps/details?id=com.melodis.midomiMusicIdentifier.freemium&amp;hl=en&amp;gl=US" target="_blank">{android()}Android</a></li>
                                <li className="mac"><a href="https://apps.apple.com/us/app/soundhound-music-discovery/id355554941" target="_blank">{apple()}MAC</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="nameTitle">SoundHound</div>

                </div>
                <div className="download-icons">
                    <div className="icon">
                        <div id="window-1" className="img">
                            <figure> <img src="https://hp.entertzone.com/images/download-icons/icon-24.png" /> </figure>
                        </div>
                        <div className="content fade-in">
                            <ul>
                                <li className="pc"><a href="https://play.google.com/store/apps/details?id=com.ubercab&amp;gl=NL" target="_blank">{android()}Android</a></li>
                                <li className="mac"><a href="https://apps.apple.com/us/app/uber/id368677368" target="_blank">{apple()}MAC</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="nameTitle">Uber</div>

                </div>
                <div className="download-icons">
                    <div className="icon">
                        <div id="window-1" className="img">
                            <figure> <img src="https://hp.entertzone.com/images/download-icons/icon-25.png" /> </figure>
                        </div>
                        <div className="content fade-in">
                            <ul>
                                <li className="pc"><a href="https://play.google.com/store/apps/details?id=me.lyft.android&amp;gl=NL" target="_blank">{android()}Android</a></li>
                                <li className="mac"><a href="https://apps.apple.com/us/app/lyft/id529379082" target="_blank">{apple()}MAC</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="nameTitle">lyft</div>

                </div>
                <div className="download-icons">
                    <div className="icon">
                        <div id="window-1" className="img">
                            <figure> <img src="https://hp.entertzone.com/images/download-icons/icon-26.png" /> </figure>
                        </div>
                        <div className="content fade-in">
                            <ul>
                                <li className="pc"><a href="https://facetime-free-calls-android.en.softonic.com/android/download" target="_blank">{android()}Android</a></li>
                                <li className="mac"><a href="https://apps.apple.com/us/app/facetime/id1110145091" target="_blank">{apple()}MAC</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="nameTitle">Facetime</div>

                </div>
                <div className="download-icons">
                    <div className="icon">
                        <div id="window-1" className="img">
                            <figure> <img src="https://hp.entertzone.com/images/download-icons/icon-6.png" /> </figure>
                        </div>
                        <div className="content fade-in">
                            <ul>
                                <li className="pc"><a href="hhttps://zoom.us/download" target="_blank">{android()}Android</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="nameTitle">Zoom</div>

                </div>
                <div className="download-icons">
                    <div className="icon">
                        <div id="window-1" className="img">
                            <figure> <img src="https://hp.entertzone.com/images/download-icons/icon-7.png" /> </figure>
                        </div>
                        <div className="content fade-in">
                            <ul>
                                <li className="pc"><a href="https://filezilla-project.org/download.php?type=client" target="_blank">{android()}Android</a></li>
                                <li className="mac"><a href="https://filezilla-project.org/download.php?platform=osx" target="_blank">{apple()}MAC</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="nameTitle">Filezilla</div>

                </div>

                <div className="download-icons">
                    <div className="icon">
                        <div id="window-1" className="img">
                            <figure> <img src="https://hp.entertzone.com/images/download-icons/icon-9.png" /> </figure>
                        </div>
                        <div className="content fade-in">
                            <ul>
                                <li className="pc"><a href="https://microsoft-edge.en.softonic.com/download" target="_blank">{android()}Android</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="nameTitle">Explorer</div>

                </div>
                <div className="download-icons">
                    <div className="icon">
                        <div id="window-1" className="img">
                            <figure> <img src="https://hp.entertzone.com/images/download-icons/icon-10.png" /> </figure>
                        </div>
                        <div className="content fade-in">
                            <ul>
                                <li className="windows"><a href="https://get.adobe.com/reader/" target="_blank"><i className="material-icons">window</i>Windows</a></li>
                                <li className="mac"><a href="https://get.adobe.com/reader/" target="_blank">{apple()}MAC</a></li>
                                <li className="mac"><a href="https://play.google.com/store/apps/details?id=com.adobe.reader" target="_blank">{android()}Android</a></li>
                                <li className="other"><a href="https://get.adobe.com/reader/" target="_blank">Other</a></li>

                            </ul>
                        </div>
                    </div>
                    <div className="nameTitle">Acrobat Reader</div>

                </div>
                <div className="download-icons">
                    <div className="icon">
                        <div id="window-1" className="img">
                            <figure> <img src="https://hp.entertzone.com/images/download-icons/icon-18.png" /> </figure>
                        </div>
                        <div className="content fade-in">
                            <ul>
                                <li className="other"><a href="https://www.microsoft.com/en-us/p/convert-units-hd/9wzdncrfjb0q?activetab=pivot:overviewtab" target="_blank">Download</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="nameTitle">Convert Units HD</div>

                </div>
                <div className="download-icons">
                    <div className="icon">
                        <div id="window-1" className="img">
                            <figure> <img src="https://hp.entertzone.com/images/download-icons/icon-12.png" /> </figure>
                        </div>
                        <div className="content fade-in">
                            <ul>
                                <li className="windows"><a href="https://www.torproject.org/download/#downloads" target="_blank"><i className="material-icons">window</i>Windows</a></li>
                                <li className="mac"><a href="https://www.torproject.org/download/#downloads" target="_blank">{apple()}MAC</a></li>
                                <li className="pc"><a href="https://www.torproject.org/download/#downloads" target="_blank">{android()}Android</a></li>
                                <li className="other"><a href="https://www.torproject.org/download/#downloads" target="_blank">Other</a></li>
                            </ul>

                        </div>
                    </div>
                    <div className="nameTitle">Tor</div>

                </div>
                <div className="download-icons">
                    <div className="icon">
                        <div id="window-1" className="img">
                            <figure> <img src="https://hp.entertzone.com/images/download-icons/icon-13.png" /> </figure>
                        </div>
                        <div className="content fade-in">
                            <ul>
                                <li className="pc"><a href="https://kodi.tv/download/android" target="_blank">{android()}Android</a></li>
                                <li className="windows"><a href="https://kodi.tv/download/windows" target="_blank"><i className="material-icons">window</i>Windows</a></li>
                                <li className="mac"><a href="https://kodi.tv/download/ios" target="_blank">{apple()}MAC</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="nameTitle">Kodi</div>

                </div>
                <div className="download-icons">
                    <div className="icon">
                        <div id="window-1" className="img">
                            <figure> <img src="https://hp.entertzone.com/images/download-icons/icon-14.png" /> </figure>
                        </div>
                        <div className="content fade-in">
                            <ul>
                                <li className="pc"><a href="https://www.minitool.com/download-center/" target="_blank">{android()}Android</a></li>
                                <li className="mac"><a href="https://www.minitool.com/download-center/" target="_blank">{apple()}MAC</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="nameTitle">Minitool</div>

                </div>
                <div className="download-icons">
                    <div className="icon">
                        <div id="window-1" className="img">
                            <figure> <img src="https://hp.entertzone.com/images/download-icons/icon-15.png" /> </figure>
                        </div>
                        <div className="content fade-in">
                            <ul>
                                <li className="pc"><a href="https://www.dropbox.com/install" target="_blank">{android()}Android</a></li>
                                <li className="mac"><a href="https://www.dropbox.com/install" target="_blank">{apple()}MAC</a></li>
                                <li className="pc"><a href="https://apps.apple.com/us/app/dropbox/id327630330" target="_blank"><i className="material-icons">window</i>windows</a></li>
                                <li className="mac"><a href="https://www.dropbox.com/" target="_blank">Other</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="nameTitle">Dropbox</div>

                </div>
                <div className="download-icons">
                    <div className="icon">
                        <div id="window-1" className="img">
                            <figure> <img src="https://hp.entertzone.com/images/download-icons/icon-8.png" /> </figure>
                        </div>
                        <div className="content fade-in">
                            <ul>
                                <li className="pc"><a href="https://www.7-zip.org/" target="_blank">{android()}Android</a></li>
                                <li className="mac"><a href="https://www.7-zip.org/" target="_blank"><i className="material-icons">window</i>window</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="nameTitle">7-zip</div>

                </div>
                <div className="download-icons">
                    <div className="icon">
                        <div id="window-1" className="img">
                            <figure> <img src="https://hp.entertzone.com/images/download-icons/icon-3.png" /> </figure>
                        </div>
                        <div className="content fade-in">
                            <ul>
                                <li className="pc"><a href="https://apps.apple.com/us/app/qr-code-reader/id1200318119" target="_blank">{android()}Android</a></li>
                                <li className="mac"><a href="https://apps.apple.com/us/app/qr-code-reader/id1200318119" target="_blank">{apple()}Mac</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="nameTitle">QR reader</div>

                </div>
                <div className="download-icons">
                    <div className="icon">
                        <div id="window-1" className="img">
                            <figure> <img src="https://hp.entertzone.com/images/download-icons/icon-21.png" /> </figure>
                        </div>
                        <div className="content fade-in">
                            <ul>
                                <li className="pc"><a href="https://play.google.com/store/apps/details?id=com.geekslab.qrbarcodescanner.pro&amp;hl=de" target="_blank">{android()}Android</a></li>
                                <li className="mac"><a href="https://play.google.com/store/apps/details?id=com.geekslab.qrbarcodescanner.pro&amp;hl=de" target="_blank">{apple()}Mac</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="nameTitle">Barcode Scanner Pro</div>

                </div>
                <div className="download-icons">
                    <div className="icon">
                        <div id="window-1" className="img">
                            <figure> <img src="https://hp.entertzone.com/images/download-icons/icon-30.png" /> </figure>
                        </div>
                        <div className="content fade-in">
                            <ul>
                                <li className="pc"><a href="https://play.google.com/store/apps/details?id=com.paypal.android.p2pmobile&amp;gl=NL" target="_blank">{android()}Android</a></li>
                                <li className="mac"><a href="https://apps.apple.com/nl/app/paypal/id283646709" target="_blank">{apple()}Ios</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="nameTitle">Paypal</div>

                </div>
                <div className="download-icons">
                    <div className="icon">
                        <div id="window-1" className="img">
                            <figure> <img src="https://hp.entertzone.com/images/download-icons/icon-31.png" /> </figure>
                        </div>
                        <div className="content fade-in">
                            <ul>
                                <li className="pc"><a href="https://play.google.com/store/apps/details?id=com.venmo&amp;hl=de" target="_blank">{android()}Android</a></li>
                                <li className="mac"><a href="https://apps.apple.com/us/app/venmo/id351727428" target="_blank">{apple()}Ios</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="nameTitle">Venmo</div>

                </div>
                <div className="download-icons">
                    <div className="icon">
                        <div id="window-1" className="img">
                            <figure> <img src="https://hp.entertzone.com/images/download-icons/icon-32.png" /> </figure>
                        </div>
                        <div className="content fade-in">
                            <ul>
                                <li className="pc"><a href="https://play.google.com/store/apps/details?id=com.zellepay.zelle&amp;hl=de" target="_blank">{android()}Android</a></li>
                                <li className="mac"><a href="https://apps.apple.com/us/app/zelle/id1260755201" target="_blank">{apple()}Ios</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="nameTitle">Zelle</div>

                </div>
                <div className="download-icons">
                    <div className="icon">
                        <div id="window-1" className="img">
                            <figure> <img src="https://hp.entertzone.com/images/download-icons/icon-33.png" /> </figure>
                        </div>
                        <div className="content fade-in">
                            <ul>
                                <li className="pc"><a href="https://play.google.com/store/apps/details?id=com.touchtunes.android&amp;hl=de" target="_blank">{android()}Android</a></li>
                                <li className="mac"><a href="https://apps.apple.com/us/app/touchtunes/id378351144" target="_blank">{apple()}Ios</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="nameTitle">Touch Tune</div>

                </div>
            </div>
        </DownloadGalleryTheme>
    )
}


DownloadGallery.prototype.Props = DownloadGalleryAttributes;


export default DownloadGallery;